import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes, Navigate } from "react-router-dom";
import { thunk } from "redux-thunk";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { Provider } from "react-redux";

import Login from "./Components/Login";
import LandingPage1 from "./LandingPage";
import Loader from "./Components/CommonServices/Loader";

import SpinnerReducer from "./Components/Reducer/SpinnerReducer";
import GetTokenReducer from "./Components/Reducer/TokenDetailsformLogin";
// import PO2025OptionForm from "./Components/PO2025OptionForm";

const reducer = combineReducers({
  spinner: SpinnerReducer,
  gettokenreducer: GetTokenReducer,
});

export const store = createStore(reducer, applyMiddleware(thunk));

function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");

  return token ? children : <Navigate to="/Login" replace />;
}

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Loader />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          {/* <Route path="/OptionForm" element={<PO2025OptionForm />} /> */}

          <Route path="/*" element={<PrivateRoute> <LandingPage1 /> </PrivateRoute>} />
        </Routes>
      </div>
    </Provider>
  );
}

export default App;
